import { Routes } from '@angular/router';
import { authGuard, guestGuard, systemAdminGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: '',
    canActivate: [authGuard, systemAdminGuard],
    loadComponent: () =>
      import('./shared/layouts/app-layout/app-layout.component').then((m) => m.AppLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'revenue',
        loadComponent: () =>
          import('./features/revenue/revenue.component').then((m) => m.RevenueComponent),
      },
      {
        path: 'tenants',
        loadComponent: () =>
          import('./features/tenants/tenant-list/tenant-list.component').then(
            (m) => m.TenantListComponent
          ),
      },
      {
        path: 'tenants/new',
        loadComponent: () =>
          import('./features/tenants/tenant-create/tenant-create.component').then(
            (m) => m.TenantCreateComponent
          ),
      },
      {
        path: 'tenants/:id/merchant-accounts/new',
        loadComponent: () =>
          import('./features/tenants/tenant-merchant-accounts/tenant-merchant-account-form.component').then(
            (m) => m.TenantMerchantAccountFormComponent
          ),
      },
      {
        path: 'tenants/:id/merchant-accounts/:accountId/edit',
        loadComponent: () =>
          import('./features/tenants/tenant-merchant-accounts/tenant-merchant-account-form.component').then(
            (m) => m.TenantMerchantAccountFormComponent
          ),
      },
      {
        // Before 'tenants/:id' — Angular matches in order, and :id would swallow
        // 'settings' otherwise. Same reason the merchant-account routes sit above.
        path: 'tenants/:id/settings',
        loadComponent: () =>
          import('./features/tenants/tenant-settings/tenant-settings.component').then(
            (m) => m.TenantSettingsComponent
          ),
      },
      {
        path: 'tenants/:id',
        loadComponent: () =>
          import('./features/tenants/tenant-detail/tenant-detail.component').then(
            (m) => m.TenantDetailComponent
          ),
      },
      {
        path: 'transactions',
        loadComponent: () =>
          import('./features/transactions/transaction-list/transaction-list.component').then(
            (m) => m.TransactionListComponent
          ),
      },
      {
        path: 'transactions/:id',
        loadComponent: () =>
          import('./features/transactions/transaction-detail/transaction-detail.component').then(
            (m) => m.TransactionDetailComponent
          ),
      },
      {
        path: 'platform-invoices',
        loadComponent: () =>
          import('./features/platform-invoices/platform-invoice-list/platform-invoice-list.component').then(
            (m) => m.PlatformInvoiceListComponent
          ),
      },
      {
        path: 'tools',
        loadComponent: () =>
          import('./features/tools/tools.component').then((m) => m.ToolsComponent),
      },
      {
        path: 'platform-documents',
        loadComponent: () =>
          import('./features/platform-documents/platform-document-list.component').then(
            (m) => m.PlatformDocumentListComponent
          ),
      },
      {
        path: 'platform-documents/:id',
        loadComponent: () =>
          import('./features/platform-documents/platform-document-detail.component').then(
            (m) => m.PlatformDocumentDetailComponent
          ),
      },
      {
        path: 'fiscal-receipts',
        loadComponent: () =>
          import('./features/fiscal-receipts/fiscal-receipt-list/fiscal-receipt-list.component').then(
            (m) => m.FiscalReceiptListComponent
          ),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
